import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';
import { getAfcSummary } from '../../common/endpoints';
const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchAfcSummary = createApi(
  getAfcSummary,
  'GET'
);

const afcSummarySlice = createSlice({
  name: 'getAfcSummary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAfcSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAfcSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAfcSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default afcSummarySlice.reducer;